import React from "react";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  return (
    <header className="header">
      <div className="logo" style={{ cursor: "pointer" }} onClick={() => navigate("/products")}>
        Loja<span>RC</span>
      </div>
      <nav>
        <ul>
          <li onClick={() => navigate("/products")}>Todos Produtos</li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
